import styled from "styled-components";
import colors from "../../../../config/colors";
import fonts from "../../../../config/fonts";
import { isMobile } from "../../../../utils/common";

export const FeaturesContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  ${isMobile()
    ? ``
    : `
    width: 90vw;
    margin: 40px 0px;`}
`;

export const FeatureSelector = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.background};
  margin-bottom: 500px;
  padding: 0px 50px;
  box-sizing: border-box;
`;
export const FeatureOption = styled.div`
  background-color: ${(props) =>
    props.active ? colors.secondary : colors.background};
  color: ${(props) => (props.active ? colors.background : colors.darkPrimary)};
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  transition: all 0.2s;
  font-size: ${(props) => (props.active ? "22px" : "20px")};
  :hover {
    color: ${(props) => (props.active ? colors.background : colors.secondary)};
    cursor: pointer;
  }
  padding: 5px 30px;
  border-radius: 200px;
`;
export const FeatureSection = styled.div`
  box-sizing: border-box;
  background-color: ${colors.primary}30;
  border-radius: 40px;
  ${isMobile()
    ? `
    margin: 20px 0px;
    width: 95vw;
    padding:30px 20px;
    `
    : `
    display: flex;
    margin: 80px 0px;
    align-items: center;
    justify-content: space-around;
    box-sizing: border-box;
    transition: all 0.2s;
    position: absolute;
    width: 90vw;
    padding: 55px;
    height:420px;
  `}
  ${(props) =>
    props.onDisplay || isMobile() ? `opacity:1;z-index:10;` : `opacity:0`};
`;
export const FeatureTextSection = styled.div`
  ${isMobile()
    ? `width:100%;`
    : `width: 60%;
  padding-${(props) => props.padddingSide}: 150px;`}

  box-sizing: border-box;
`;
export const FeatureHeading = styled.div`
  ${fonts.headings};
  font-size: 35px;
  font-weight: bold;
  margin-bottom: ${isMobile() ? "30px" : "50px"};
  ${isMobile() &&
  `
      text-align:center;
      font-size:24px;
    `}
`;
export const FeatureText = styled.div`
  ${fonts.text};
  font-size: 16px;
  margin-bottom: ${isMobile() ? "30px" : "50px"};
`;
export const FeatureImageContainer = styled.div`
  ${isMobile()
    ? `
  width: 100%;`
    : `
  width: 35%;`}
`;
export const FeatureImage = styled.img`
  width: 100%;
  border-radius: 40px;
`;

export const DashboardButtonContainer = styled.div`
  margin: 30px 0px;
  ${isMobile()
    ? `
    display:flex;
    align-items:center;
    justify-content:center;
  `
    : ``}
`;
